import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../layout/DashboardLayout";
import PropTypes from "prop-types";
const Protected = (props) => {
  const { Component,navigation } = props;
  const navigate = useNavigate();
  useEffect(() => {
    let accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      navigate("/login");
    }
  });
  return (
    <DashboardLayout navigation={navigation} >
      <Component/>
    </DashboardLayout>
  );
};
Protected.propTypes = {
  Component: PropTypes.elementType.isRequired, 
};
export default Protected
